// extracted by mini-css-extract-plugin
export default {"container":"films_container__1x1BW","grid":"films_grid__3n52a"};